import { render, staticRenderFns } from "./SamsPayUclanAgent.vue?vue&type=template&id=74652115"
import script from "./SamsPayUclanAgent.vue?vue&type=script&lang=js"
export * from "./SamsPayUclanAgent.vue?vue&type=script&lang=js"
import style0 from "./SamsPayUclanAgent.vue?vue&type=style&index=0&id=74652115&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports